<!-- cdkDrag cdkDragRootElement=".cdk-overlay-pane"-->
<div [@mobileDialogAnimation]>
  <div [ngClass]="useMobileAnimation? 'd1':'d1-desktop'">

    <div class="overlay background">

      <div class="close-form" style="cursor: pointer;display: flex; justify-content: center; align-items: center;" (click)="closeDialog()">
        <fa-icon icon="times"  aria-label="Close" [matTooltip]="'Close'"
        matTooltipPosition="above"></fa-icon>
      </div>

      <div class="dialog-container gradient">
        @switch (renderMethod) {
          @case ('text') {
            <div [innerHTML]="content"></div>
          }
          @case ('template') {
            <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
          }
          @case ('component') {
            <ng-container *ngComponentOutlet="content"></ng-container>
          }
        }
      </div>
    </div>
  </div>

</div>

